export default "__VITE_ASSET__4192010f__"